import api from '../utils/api';
import config from '../config';

const queryMonitoringService = {
  // Get dashboard data with statistics and charts
  getDashboard: async (filters) => {
    return api.get(`${config.api.baseURL}/vneid/query-monitoring/dashboard`, filters);
  },

  // Get query history with pagination
  getQueryHistory: async (filters) => {
    return api.get(`${config.api.baseURL}/vneid/query-monitoring/history`, filters);
  },

  // Get query statistics
  getStatistics: async (filters) => {
    return api.get(`${config.api.baseURL}/vneid/query-monitoring/statistics`, filters);
  },

  // Get volume data for charts
  getVolumeData: async (filters) => {
    return api.get(`${config.api.baseURL}/vneid/query-monitoring/volume`, filters);
  },

  // Get query type distribution
  getTypeDistribution: async (filters) => {
    return api.get(`${config.api.baseURL}/vneid/query-monitoring/type-distribution`, filters);
  },

  // Export monthly report
  exportMonthlyReport: async (year, month, format = 'excel') => {
    const response = await api.get(`${config.api.baseURL}/vneid/query-monitoring/export/monthly`, { year, month, format }, { responseType: 'blob' });

    const fileName = `VNeID_Monthly_Report_${year}_${month.toString().padStart(2, '0')}.${format === 'pdf' ? 'pdf' : 'xlsx'}`;
    const url = window.URL.createObjectURL(new Blob([response]));
    const link = document.createElement('a');
    link.href = url;
    link.setAttribute('download', fileName);
    document.body.appendChild(link);
    link.click();
    link.remove();
    window.URL.revokeObjectURL(url);

    return { message: 'Monthly report downloaded successfully' };
  },

  // Export quarterly report
  exportQuarterlyReport: async (year, quarter, format = 'excel') => {
    const response = await api.get(`${config.api.baseURL}/vneid/query-monitoring/export/quarterly`, { year, quarter, format }, { responseType: 'blob' });

    const fileName = `VNeID_Quarterly_Report_${year}_Q${quarter}.${format === 'pdf' ? 'pdf' : 'xlsx'}`;
    const url = window.URL.createObjectURL(new Blob([response]));
    const link = document.createElement('a');
    link.href = url;
    link.setAttribute('download', fileName);
    document.body.appendChild(link);
    link.click();
    link.remove();
    window.URL.revokeObjectURL(url);

    return { message: 'Quarterly report downloaded successfully' };
  },

  // Get all alert configurations
  getAlerts: async () => {
    return api.get(`${config.api.baseURL}/vneid/query-monitoring/alerts`);
  },

  // Configure new alert
  configureAlert: async (alertData) => {
    return api.post(`${config.api.baseURL}/vneid/query-monitoring/alerts`, alertData);
  },

  // Update alert configuration
  updateAlert: async (alertData) => {
    return api.put(`${config.api.baseURL}/vneid/query-monitoring/alerts/${alertData.id}`, alertData);
  },

  // Delete alert configuration
  deleteAlert: async (id) => {
    return api.delete(`${config.api.baseURL}/vneid/query-monitoring/alerts/${id}`);
  },
};

export default queryMonitoringService;
